module.exports = __webpack_public_path__ + "static/media/paco-rabanne-lady-million-prive-big.0ecf23da.png";